import { Tabs } from 'antd';
import FundamentalDomains from './FundamentalDomains';
import styles from "./Domains.module.scss";
import Layout from "../../Containers/Layout";
import Domains from './Domains';
import { useHistory, useLocation } from 'react-router-dom';
import { useState } from 'react';
import ScienceBranches from './ScienceBranches';

const { TabPane } = Tabs;

const TabsComponent = () => {
    const location = useLocation();
    const history = useHistory();
    const [activeTab, setActiveTab] = useState(location.state !== undefined && location.state !== null ? (location.state as any).activeTab : "1"); // todo: change tabs to enum type

    return <div className={styles.container} style={{ display: "flex", flexDirection: "column", marginTop: "0%" }}>
        <Layout>
            <Tabs 
                defaultActiveKey='1'
                activeKey={activeTab}
                onChange={(nextTab) => {
                    setActiveTab(nextTab);
                    history.replace({ pathname: location.pathname, state: { activeTab: nextTab } });
                }}>
                <TabPane tab="Domenii de studiu" key="1">
                    <Domains />
                </TabPane>
                <TabPane tab="Ramuri de stiinta" key="2">
                    <ScienceBranches />
                </TabPane>
                <TabPane tab="Domenii fundamentale" key="3">
                    <FundamentalDomains />
                </TabPane>
            </Tabs>
        </Layout>
    </div>
}

export default TabsComponent;
